export default "__VITE_ASSET__BwBbHRfe__"